import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["value", "onBottomNavActionChange", "isDark", "dark", "centered", "full", "className", "style", "htmlProps", "children"];
import { Children, cloneElement, isValidElement } from 'react';
import cn from 'classnames';
import transition from "../styles/transition";
import { jsx as _jsx } from "react/jsx-runtime";
var BottomNavigation = function BottomNavigation(_ref) {
  var value = _ref.value,
    onBottomNavActionChange = _ref.onBottomNavActionChange,
    isDark = _ref.isDark,
    dark = _ref.dark,
    centered = _ref.centered,
    _ref$full = _ref.full,
    full = _ref$full === void 0 ? true : _ref$full,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    style = _ref.style,
    htmlProps = _ref.htmlProps,
    childrenProp = _ref.children,
    bottomNavigationProps = _objectWithoutProperties(_ref, _excluded);
  var children = Children.map(childrenProp, function (child, index) {
    if (! /*#__PURE__*/isValidElement(child)) {
      return null;
    }
    var childValue = child.props.value === undefined ? index : child.props.value;
    var selected = childValue === value;
    var onClick = function onClick(e) {
      if (typeof onBottomNavActionChange === 'function') {
        onBottomNavActionChange(childValue);
      }
      if (typeof child.props.onClick === 'function') {
        child.props.onClick(e);
      }
    };
    return /*#__PURE__*/cloneElement(child, {
      // @ts-ignore
      onClick: onClick,
      selected: child.props.selected || selected,
      value: childValue,
      isDark: isDark,
      dark: dark
    });
  });
  return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread(_objectSpread({
    className: cn('inline-flex items-center bottom-nav z-4 shadow-bottom-nav', {
      'w-full': full,
      'justify-around': centered
    }, isDark || dark ? 'bg-gray-main-dark-mode' : 'bg-primary-light', className),
    style: _objectSpread({
      transition: transition('background-color')
    }, style)
  }, bottomNavigationProps), htmlProps), {}, {
    children: children
  }));
};
export default BottomNavigation;